<app-modal maxHeight="100vh" maxWidth="100%" modalBodyClasses="p-0">
  <div body class="flex flex-col h-full relative">

    <!-- Waiting / Joining overlays -->
    @if (!loading$() && isWaiting) {
      <div
        class="absolute flex-col inset-0 flex items-center justify-center text-white text-xl">
        <span>{{ 'WaitingForParticipant.Title' | localizeText : 'Waiting for participant...' }}</span>
        <span class="label-style">{{ 'WaitingForParticipant.Desc' | localizeText : 'Once another participant joins, they will appear here.' }}</span>
      </div>
    }

    @if (loading$()) {
      <div
        class="absolute flex-col inset-0 flex items-center justify-center text-white text-xl">
        <app-loader-small></app-loader-small>
      </div>
    }

    <!-- Spotlight -->
    <div class="flex-1 flex overflow-hidden">
      @if (focused$()) {
        <app-participant-view
          [participant]="focused$()"
          size="large"
          class="flex-1"
        ></app-participant-view>
      }
    </div>

    @if (invitingPhone$) {
      <div class="flex flex-col absolute p-2 z-20 space-y-1 top-[52px] right-0 bg-gray-700 rounded" style="width: 200px;">
        <app-intl-phone-num fontSize="16px" (phoneNumberChanged)="phoneInviting$ = $event.e164Number"></app-intl-phone-num>
        <div class="flex justify-end">
          <app-button [loading$]="loadingInvite$()" (click)="inviteViaPhone()">{{ 'Invite' | localizeText : 'Invite' }}</app-button>
        </div>
      </div>
    }

    <!-- Thumbnails + local -->
    <div class="absolute right-0 top-0 bottom-0 w-36 flex flex-col gap-2 overflow-y-auto" style="overflow-x: visible">

      <!-- Participant phone invite -->
      <div class="small relative flex flex-col py-1 bg-gray-700 cursor-pointer hover:bg-opacity-80 transition-all rounded">
        <div class="flex justify-between items-center cursor-pointer p-1" (click)="invitingPhone$ = !invitingPhone$">
          <app-icon fontSize="26px" lineHeight="24px" class="text-center" icon="mdi-account-multiple-plus-outline"></app-icon>
          @if (invitingPhone$) {
            <app-icon fontSize="26px" lineHeight="24px" class="text-center" icon="mdi-chevron-down"></app-icon>
          }
          @if (!invitingPhone$) {
            <app-icon fontSize="26px" lineHeight="24px" class="text-center" icon="mdi-chevron-right"></app-icon>
          }
        </div>
      </div>

      <!-- Local preview -->
      <div class="relative">
        <div #localPreview class="small rounded shadow-lg" [class.hidden]="!videoEnabled$()"></div>
        @if (loggedInUserName$()) {
          <span class="absolute bottom-0 left-0 right-0 text-center rounded-b label-style" style="background: rgba(0,0,0,0.4)">
            {{ loggedInUserName$() }}
          </span>
        }
      </div>

      <!-- remote thumbs -->
      @for (p of participantsDisplaying; track p) {
        <div class="relative">
          <app-participant-view
            [participant]="p"
            size="small"
            [class.opacity-50]="p.sid !== focused$()?.sid"
            (click)="select(p.sid)"
          ></app-participant-view>
          <span class="absolute bottom-0 left-0 right-0 text-center rounded-b label-style" style="background: rgba(0,0,0,0.4)">{{ nameMapping[p.identity] }}</span>
        </div>
      }
    </div>

    <div class="absolute left-0 right-0 bottom-0 flex justify-center">
      <div class="flex flex-col py-2 px-6 rounded-full bg-gray-850">

        @if (focused$()) {
          <span class="label-style pb-1 text-center">{{ nameMapping[focused$().identity] }}</span>
        }

        <div class="flex justify-center space-x-2">
          <div class="" (click)="leaveRoom()">
            <app-icon
              classList="p-2 text-white rounded-full flex items-center cursor-pointer bg-red-900 hover:bg-opacity-60 transition-all"
            fontSize="26px" lineHeight="22px" icon="mdi-phone-hangup"></app-icon>
          </div>

          <div  (click)="toggleAudio()">
            <app-icon
              classList="p-2 rounded-full flex items-center cursor-pointer bg-gray-950 hover:bg-opacity-60 transition-all text-white"
            fontSize="26px" lineHeight="22px" icon="{{ audioEnabled$() ? 'mdi-microphone' : 'mdi-microphone-off' }}"></app-icon>
          </div>

          <div  (click)="toggleVideo()">
            <app-icon
              classList="p-2 rounded-full flex items-center cursor-pointer bg-gray-950 hover:bg-opacity-60 transition-all text-white"
            fontSize="26px" lineHeight="22px"  icon="{{ videoEnabled$() ? 'mdi-video' : 'mdi-video-off' }} "></app-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-modal>
